<mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading | async"></mat-progress-bar>
